import http from "../http-common";

class UsuariAplicacioService {

    getUsuariLoguejatuari(){
        return http.get("/usuari/usuari-loguejat");
    }

    listUsuaris(data) {
        return http.get("/usuari/list", data);
    }

    listRols(data) {
        return http.get("/usuari/rols/list", data);
    }

    entitatUsuari() {
        return http.get("/entitat");
    }

    saveUsuari(form){
        let data = {};
        console.log(form.idUsuari);
        console.log(data);
        data.idUsuari = form.idUsuari
        data.nomUsuari = form.nomUsuari;
        data.pass = form.pass;
        data.rols = form.rols;
        data.organitzacio = form.organitzacio;
        data.dataCreacio = form.dataCreacio;
        data.entitat = form.entitat;
        console.log("UsuariAplicacioService.js --> form: ");
        console.log(form);
        console.log("UsuariAplicacioService.js --> data: ");
        console.log(data);
        if(data.idUsuari != null){
            return http.put("/usuari",data);
        }else{
            return http.post("/usuari",data);
        }

    }

    eliminarUsuari(idUsuari){
        return http.delete("/usuari/"+idUsuari);
    }

    donarBaixaUsuari(idUsuari){
        return http.put("/usuari/baixa/"+idUsuari);
    }
}

export default new UsuariAplicacioService();